var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "ai-score-guide-modal",
      attrs: {
        id: "ai-score-guide-modal",
        centered: "",
        "hide-header": "",
        "hide-footer": ""
      }
    },
    [
      _c("div", { staticClass: "ai-score-guide-modal__main" }, [
        _c("div", { staticClass: "ai-score-guide-modal__header text-right" }, [
          _c("img", {
            staticClass: "clickable",
            attrs: {
              src: "/static/images/score-guide-close.svg",
              alt: "close modal"
            },
            on: {
              click: function($event) {
                return _vm.$refs.modal.hide()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ai-score-guide-modal__body" }, [
          _c("div", {
            staticClass: "ai-score-guide-modal__title text-center",
            domProps: {
              innerHTML: _vm._s(_vm.$t("ai_report.score_guide.title"))
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "ai-score-guide-modal__description text-center mx-auto",
            domProps: {
              innerHTML: _vm._s(_vm.$t("ai_report.score_guide.description"))
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ai-score-guide-modal__score-list text-center" },
            _vm._l(_vm.aiGradeCount, function(i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "ai-score-guide-modal__score-list-item"
                },
                [
                  _c(
                    "div",
                    { staticClass: "ai-score-guide-modal__score-label" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("ai_report.score_guide.score_label_" + i)
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ai-score-guide-modal__score-value" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("ai_report.score_guide.score_value_" + i)
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21764a7b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21764a7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AiScoreGuideModal.vue
// module id = 8zvC
// module chunks = 1